import React from 'react'

// Pages principales
const DashboardPage = React.lazy(() => import('./backpages/DashboardPage'))
const EspacePrierePage = React.lazy(() => import('./backpages/EspacePrierePage'))
const BibleMeditationPage = React.lazy(() => import('./backpages/BibleMeditationPage'))
const JournalPage = React.lazy(() => import('./backpages/JournalPage'))
const GaleriePage = React.lazy(() => import('./backpages/GaleriePage'))
const CommunautePage = React.lazy(() => import('./backpages/CommunautePage'))
const RessourcesPage = React.lazy(() => import('./backpages/RessourcesPage'))
const ProgressionPage = React.lazy(() => import('./backpages/ProgressionPage'))
const CalendrierPage = React.lazy(() => import('./backpages/CalendrierPage'))
const NotificationPage = React.lazy(() => import('./backpages/NotificationPage'))
const MessagePage = React.lazy(() => import('./backpages/MessagePage'))
const TasksPage = React.lazy(() => import('./backpages/TasksPage'))
const MemberManagerPage = React.lazy(() => import('./backpages/MemberManagerPage'))
const ImpactEvangeliquePage = React.lazy(() => import('./backpages/ImpactEvangeliquePage'))

// Pages additionnelles
const ProfilPage = React.lazy(() => import('./backpages/ProfilPage'))
const DashboardPartnershipDetailsPage = React.lazy(() =>
    import('./backpages/DashboardPartnershipDetailsPage')
)
const SettingPage = React.lazy(() => import('./backpages/SettingPage'))

// Pages dynamiques pour notification/message individuelle
const NotificationDetailPage = React.lazy(() => import('./backpages/NotificationDetailPage'))
const MessageDetailPage = React.lazy(() => import('./backpages/MessageDetailPage'))
const ServicesPage = React.lazy(() => import('./backpages/ServicesPage'))
const IntercessionsPage = React.lazy(() => import('./backpages/IntercessionsPage'))

const routesBack = [
   { path: '', name: 'Tableau de bord', element: <DashboardPage /> },        // /dashboard
   { path: 'espace-priere', name: 'Mon espace prière', element: <EspacePrierePage /> },
   { path: 'bible-meditation', name: 'Bible & Méditation', element: <BibleMeditationPage /> },
   { path: 'journal', name: 'Mon Journal', element: <JournalPage /> },
   { path: 'galerie', name: 'Galerie', element: <GaleriePage /> },
   { path: 'communaute', name: 'Communauté', element: <CommunautePage /> },
   { path: 'ressources', name: 'Ressources', element: <RessourcesPage /> },
   { path: 'progression', name: 'Ma Progression', element: <ProgressionPage /> },
   { path: 'calendrier', name: 'Calendrier', element: <CalendrierPage /> },
   { path: 'intercession', name: 'Intercessions', element: <IntercessionsPage /> },
   { path: 'intercession/:slug', name: 'Intercessions', element: <IntercessionsPage /> },
   { path: 'notifications', name: 'Notification', element: <NotificationPage /> },
   { path: 'messages', name: 'Messages', element: <MessagePage /> },
   { path: 'tasks', name: 'Taches', element: <TasksPage /> },
   { path: 'mymember', name: 'Taches', element: <MemberManagerPage /> },
   { path: 'impact-evengelique', name: 'Taches', element: <ImpactEvangeliquePage /> },

   // Routes dynamiques pour détails
   { path: 'notification/:id', name: 'Détail Notification', element: <NotificationDetailPage /> },
   { path: 'message/:id', name: 'Détail Message', element: <MessageDetailPage /> },

   // 👤 Profil
   { path: 'profil', name: 'Profil', element: <ProfilPage /> },

   // 🔗 Partenariat (détail dynamique)
   { path: 'partnership/:id', name: 'Détail partenariat', element: <DashboardPartnershipDetailsPage /> },

   // ⚙️ Paramètres
   { path: 'parametres', name: 'Paramètres', element: <SettingPage /> },
   { path: 'services', name: 'Services', element: <ServicesPage /> },
]

export default routesBack
